import { ListProductPriceOut } from '../store/api';
import { Price } from '../../models/Article';

export const mapValidItems = <T, U>(
    array: ReadonlyArray<T>,
    filter: (elem: T) => boolean,
    mapping: (elem: T) => U
): ReadonlyArray<U> => {
    return array.filter(filter).map(mapping);
};

const UNAVAILABLE_PRICE = {};
export const mapListProductPriceOutToPrice = (price?: ListProductPriceOut): Price => {
    if (!price) return UNAVAILABLE_PRICE;

    return price;
};
